

import baseAPI from '@/http'

const router = 'api/uf'

export const ufAPI = {
    list: (tipo) => baseAPI.get(`${router}/obter-ufs?tipoInscricao=${tipo}`),

}